module.exports = __webpack_public_path__ + "media/military/military_hc_btn_hover-ec322c6a.png";